import React, { useEffect, useState } from 'react'
import { Form } from '@themesberg/react-bootstrap'

const ImageUpload = ({ value, onChange }) => {
  const [preview, setPreview] = useState('')
  const [fileName, setFileName] = useState('')

  useEffect(() => {
    if (typeof value === 'string' && value) {
      // If it's already a base64 string or URL
      if (value.startsWith('http') || value.startsWith('data:')) {
        setPreview(value)
      } else {
        // Convert base64 to data URL for preview
        setPreview(`data:image/jpeg;base64,${value}`)
      }
    } else {
      setPreview('')
      setFileName('')
    }
  }, [value])

  const handleFileChange = (evt) => {
    const file = evt.target.files && evt.target.files[0]
    if (!file) {
      setPreview('')
      setFileName('')
      onChange(null)
      return
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
    if (!allowedTypes.includes(file.type)) {
      alert('Chỉ chấp nhận file hình: JPEG, PNG, GIF, WebP')
      return
    }

    const maxSize = 10 * 1024 * 1024
    if (file.size > maxSize) {
      alert('File quá lớn. Kích thước tối đa là 10MB')
      return
    }

    // Convert File to base64
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result;
      if (result) {
        const parts = result.split(',');
        const base64String = parts.length > 1 ? parts[1] : '';
        onChange(base64String);
      } else {
        onChange('');
      }
    }
    reader.onerror = () => {
      alert('Có lỗi khi đọc file')
      onChange(null)
    }
    reader.readAsDataURL(file)
  }

  return (
    <div>
      <Form.Control 
        type="file" 
        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp" 
        onChange={handleFileChange} 
      />
      {preview && (
        <img
          alt={fileName || 'preview'}
          src={preview}
          style={{ width: 60, height: 60, objectFit: 'cover', marginTop: 6, borderRadius: 4 }}
        />
      )}
    </div>
  )
}

export default ImageUpload
